
import {
  defineComponent, onBeforeMount, reactive, watch,
} from 'vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import { useGradeBase } from '@/core/composables/GradeBase';
import { useTelaBase } from '@/core/composables/TelaBase';
import { IPagination } from '@/core/models/AntDesign/IPagination';
import { IListaPaginadaMetaData } from '@/core/models/Consulta/IListaPaginada';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import { ISalvamentoAutomatico } from '@/models/Entidades/MeuSistema/ISalvamentoAutomatico';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import storeSistema from '@/store/storeSistema';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import Icone from '@/core/components/Icone.vue';
import Card from '@/core/components/Tela/Card.vue';
import { IFiltroRelatorioAnaliseEstoque } from '@/models/Relatorios/Estoque/IFiltroRelatorioAnaliseEstoque';
import { IDadosRelatorioAnaliseEstoque, IDadosRelatorioAnaliseEstoqueItem } from '@/models/Relatorios/Estoque/IDadosRelatorioAnaliseEstoque';
import ServicoRelatorioEstoque from '@/servicos/Relatorios/ServicoRelatorioEstoque';
import { ETipoRelatorioEstoque } from '@/models/Enumeradores/Relatorios/ETipoRelatorioEstoque';
import SelecionarTipoRelatorioEstoque from '@/components/Relatorios/Estoque/SelecionarTipoRelatorioEstoque.vue';
import SelecionarCategoria from '@/components/Cadastros/Produtos/SelecionarCategoria.vue';
import SelecionarMarca from '@/components/Cadastros/Produtos/SelecionarMarca.vue';
import SelecionarFornecedor from '@/components/Cadastros/Pessoas/Fornecedores/SelecionarFornecedor.vue';

export default defineComponent({
  name: 'RelatorioAnaliseEstoque',
  components: {
    TituloPadrao,
    Icone,
    Card,
    SelecionarTipoRelatorioEstoque,
    SelecionarCategoria,
    SelecionarMarca,
    SelecionarFornecedor,
    PreviewPdf,
  },
  setup(props) {
    const servicoSistema = new ServicoSistema();
    const servicoRelatorioEstoque = new ServicoRelatorioEstoque();
    const {
      telaBase, filtrarPermissaoDadosUsuarioMultiEmpresas, apresentarMensagemAlerta, apresentarMensagemErro,
      preencherEmpresasDisponiveis, verificaConceitoParaApresentarEmpresas, defineEmpresasSelecionadasComPermissao,
      preencherDadosRota,
    } = useTelaBase();
    const { gradeBase } = useGradeBase();
    const state = reactive({
      filtros: {} as IFiltroRelatorioAnaliseEstoque,
      filtrosUtilizados: {} as IFiltroRelatorioAnaliseEstoque,
      resultado: {} as IDadosRelatorioAnaliseEstoque,
      itens: [] as IDadosRelatorioAnaliseEstoqueItem[],
      paginacao: {} as IPagination,
      paginacaoAPI: { totalRegistros: 0, paginaAtual: 1 } as IListaPaginadaMetaData,
      timerRegistros: 0,
      totalRegistrosComMascara: '100',
      arquivoPdf: [] as IArquivoPdf[],
      mostrarFiltrosInteligentes: 1,
      mostrarFiltros: 0,
      mostrarItens: false,
      cacheAutomatico: {} as ISalvamentoAutomatico,
      apenasSemEstoque: false,
      apenasPontoPedido: false,
    });
    telaBase.apresentarEmpresas = false;

    function preencherColunas() {
      if (storeSistema.state.layoutMobile) {
        gradeBase.colunas = [
          {
            title: 'Código', dataIndex: 'CodigoProduto', key: 'Item', position: 1, visible: false,
          },
        ];
      } else {
        gradeBase.colunas = [
          {
            title: 'Codigo', dataIndex: 'codigoInterno', key: 'codigo', position: 1, visible: true, align: 'left', width: 150,
          },
          {
            title: 'Descricao', dataIndex: 'descricao', key: 'descricao', position: 2, visible: true, align: 'left',
          },
          {
            title: 'Unidade', dataIndex: 'unidade', key: 'unidade', position: 3, visible: true, align: 'center', width: 100,
          },
          {
            title: 'Ponto de Pedido', dataIndex: 'pontoPedido', key: 'pontoPedido', position: 4, visible: true, align: 'center', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'Estoque Atual', dataIndex: 'estoqueAtual', key: 'estoqueAtual', position: 5, visible: true, align: 'center', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
        ];
      }
    }

    function obterIdentificadorCache(): string {
      return `RELATORIO_ANALISE_ESTOQUE_${storeSistema.getters.codigoUsuarioAutenticado()}`;
    }

    function salvarCache() {
      const identificador = obterIdentificadorCache();
      state.cacheAutomatico.data = UtilitarioData.obterDataAtual();
      state.cacheAutomatico.codigoEmpresa = state.filtros.empresa;
      state.cacheAutomatico.codigoUsuario = storeSistema.getters.codigoUsuarioAutenticado();
      state.cacheAutomatico.identificador = telaBase.identificadorRecurso;
      state.cacheAutomatico.dados = JSON.stringify(state.filtros);
      servicoSistema.salvamentoAutomaticoLocalStorage(`${identificador}`, state.cacheAutomatico);
    }

    function obterTipoRelatiro() {
      switch (state.filtros.tipo) {
        case ETipoRelatorioEstoque.Marca:
          state.filtros.tipoRelatorio = 'Marca';
          break;
        case ETipoRelatorioEstoque.Categoria:
          state.filtros.tipoRelatorio = 'Categoria';
          break;
        case ETipoRelatorioEstoque.Fornecedor:
          state.filtros.tipoRelatorio = 'Fornecedor';
          break;
        default:
          state.filtros.tipoRelatorio = 'Geral';
          break;
      }
    }

    async function buscarRelatorio() {
      telaBase.carregando = true;
      state.filtros.numeroPagina = state.paginacao.current;
      state.filtros.qtdRegistrosPagina = state.paginacao.pageSize;
      state.filtros.qtdTotalRegistros = state.paginacao.total;
      state.filtros.empresa = storeSistema.getters.codigoEmpresaOperacao();
      obterTipoRelatiro();
      state.resultado = await servicoRelatorioEstoque.obterAnaliseEstoque(state.filtros);
      state.filtrosUtilizados = UtilitarioGeral.clonarObjeto(state.filtros);
      salvarCache();
      preencherColunas();
      state.mostrarItens = true;
      state.itens = state.resultado.itens.dados;
      state.paginacaoAPI = state.resultado.itens.metaData;
      state.mostrarFiltros = 0;
      state.mostrarFiltrosInteligentes = 0;
      telaBase.carregando = false;
    }

    async function alterarQuantidadeRegistroTotal(valor: any) {
      clearTimeout(state.timerRegistros);
      let totalRegistros = 100;
      state.timerRegistros = setTimeout(async () => {
        if (UtilitarioGeral.valorValido(valor)) {
          const limiteRegistros = UtilitarioMascara.removerMascaraNumero(valor);
          if (limiteRegistros > 0) {
            totalRegistros = limiteRegistros;
          }
        }
        state.paginacao.total = totalRegistros;
        state.totalRegistrosComMascara = UtilitarioMascara.mascararNumeroInteiro(totalRegistros);
        await buscarRelatorio();
      }, 600);
    }

    async function imprimir(tipoArquivoRelatorio:ETipoArquivo) {
      telaBase.carregando = true;
      if (!UtilitarioGeral.validaLista(state.itens)) {
        await buscarRelatorio();
      }
      const retornoRelatorio = await servicoRelatorioEstoque.obterArquivoAnaliseEstoque(tipoArquivoRelatorio, state.filtrosUtilizados);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivoPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(state.filtros.empresa);
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
      await buscarRelatorio();
    }

    function usarFiltroInteligente(filtro: number) {
      switch (filtro) {
        case 2:
          state.apenasPontoPedido = false;
          state.apenasSemEstoque = true;
          break;
        case 3:
          state.apenasPontoPedido = true;
          state.apenasSemEstoque = false;
          break;
        default:
          state.apenasPontoPedido = false;
          state.apenasSemEstoque = false;
          break;
      }
      buscarRelatorio();
    }

    function limparFiltros() {
      state.filtros = {} as IFiltroRelatorioAnaliseEstoque;
      state.filtros.empresa = storeSistema.getters.codigoEmpresaOperacao();
      state.filtros.tipoRelatorio = 'Geral';
      state.filtros.tipo = ETipoRelatorioEstoque.Geral;
      state.apenasPontoPedido = false;
      state.apenasSemEstoque = false;
    }

    async function onPageChange(current: number, pageSize: number) {
      state.paginacao.current = current;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    async function onShowSizeChange(current: number, pageSize: number) {
      state.paginacao.current = 1;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    watch(() => storeSistema.state.layoutMobile, () => {
      preencherColunas();
    });

    onBeforeMount(async () => {
      preencherDadosRota();
      await preencherEmpresasDisponiveis();
      await defineEmpresasSelecionadasComPermissao();
      verificaConceitoParaApresentarEmpresas();
      preencherColunas();
      limparFiltros();
      state.paginacao.total = 100;
      state.paginacao.showSizeChanger = true;
      state.paginacao.pageSize = 100;
      state.paginacao.current = 1;
      state.paginacao.pageSizeOptions = ['10', '50', '100', '500', '1000'];
    });

    return {
      state,
      props,
      window,
      ETipoArquivo,
      ECustomRenderRow,
      UtilitarioMascara,
      UtilitarioData,
      UtilitarioDispositivo,
      storeSistema,
      telaBase,
      gradeBase,
      limparFiltros,
      obterIdentificadorCache,
      salvarCache,
      buscarRelatorio,
      atualizarSelecaoEmpresas,
      usarFiltroInteligente,
      imprimir,
      alterarQuantidadeRegistroTotal,
      onPageChange,
      onShowSizeChange,
    };
  },
});
